/**
 * 计数统计事件处理
 */
let rejectCount = 0;
const CountEvent = {
  events: [] as HBEventData<YCount>[],
  count(hbEvent: HBEventData<YCount>) {
    // 同服务、相同标识的统计事件进行合并
    const find = CountEvent.events.find(item => item.ecid === hbEvent.ecid && item.ecbiz === hbEvent.ecbiz && item.servicecode === hbEvent.servicecode);
    if (find) {
      find.cnt += hbEvent.cnt;
      find.attrs.lastEvt = hbEvent.evt;
    } else {
      CountEvent.events.push(hbEvent);
    }
  },
  consume(isForce = false) {
    if(isForce || CountEvent.events.length > 10 || rejectCount > 3) {
      rejectCount = 0;
      return CountEvent.events.splice(0);
    } else {
      rejectCount += 1;
      return [];
    }
  }
};

export default CountEvent;
